import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trackActivity } from '../utils/custom-track-events';
import {
    LegacyCertificateTrackAction as CertificateTrackAction,
    LegacyTrackCategory as TrackCategory,
} from '@pok/viewer-api-sdk';
import LinkedinShortIcon from './icons/LinkedinShortIcon.jsx';
import { ExternalLink } from './ui/ExternalLink.jsx';
import Stack from '@mui/material/Stack';
import { linkedinOrganizationId } from '../interact.jsx';
import Typography from '@mui/material/Typography';

export default function LinkedinProfileButton({ disabled, cert, onSendEvent, organization }) {
    const { t } = useTranslation();
    const certDate = new Date(cert.date);
    const [link, setLink] = useState(
        'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME'
            .concat('&organizationName=')
            .concat(encodeURIComponent(cert.institution ? cert.institution : organization?.name))
            .concat('&name=')
            .concat(encodeURIComponent(cert.title))
            .concat('&certUrl=')
            .concat(encodeURIComponent(cert.url))
            .concat('&certId=')
            .concat(encodeURIComponent(cert.tokenId ?? cert.id))
            .concat('&issueYear=')
            .concat(certDate.getFullYear().toString())
            .concat('&issueMonth=')
            .concat((certDate.getMonth() + 1).toString()),
    );

    const openLink = () => {
        onSendEvent('linkedin-profile');
        trackActivity(
            TrackCategory.CERTIFICATE,
            CertificateTrackAction.ADD_TO_LINKEDIN_PROFILE,
            cert.id,
            cert.minter,
            undefined,
        ).then();
    };

    useEffect(() => {
        if (!disabled) {
            linkedinOrganizationId(cert).then((id) => {
                setLink(link.concat(id ? `&organizationId=${id}` : ''));
            });
        }
    }, [disabled]);

    return (
        <>
            <ExternalLink
                styles={{
                    width: '92%',
                    textDecoration: 'none',
                    padding: '12px',
                    borderRadius: '8px',
                    borderColor: disabled ? '#F6F6F6' : '#2867B2',
                    background: disabled ? 'rgb(246, 246, 246)' : '#2867B2',
                    cursor: disabled ? 'default' : 'pointer',
                }}
                to={link}
                disabled={disabled}
                onClick={openLink}
            >
                <Stack direction={'row'} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                    <LinkedinShortIcon fill={disabled ? '#1E1E1E' : '#FFF'} />
                    <Typography
                        variant={'bodyMenu'}
                        sx={{ color: disabled ? 'rgba(0, 0, 0, 0.26)' : 'rgb(255, 255, 255)', ml: 1 }}
                    >
                        {t('certificate.share.linkedin-profile')}
                    </Typography>
                </Stack>
            </ExternalLink>
        </>
    );
}
